import type { OpportunityStage } from '../../types/mavis';
import { OPPORTUNITY_STAGE_LABELS } from '../../types/mavis';

const STAGE_STYLES: Record<OpportunityStage, string> = {
  discover:   'bg-app-canvas text-app-muted',
  qualify:    'bg-blue-100 text-blue-700',
  validate:   'bg-amber-100 text-amber-700',
  propose:    'bg-violet-100 text-violet-700',
  negotiate:  'bg-orange-100 text-orange-700',
  close_won:  'bg-forest-100 text-forest-700',
  close_lost: 'bg-red-100 text-red-600',
};

interface Props {
  stage: OpportunityStage;
  size?: 'sm' | 'md';
}

export default function MavisStageChip({ stage, size = 'sm' }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'
      } ${STAGE_STYLES[stage]}`}
    >
      {OPPORTUNITY_STAGE_LABELS[stage]}
    </span>
  );
}
